/**
 * Returns expiry date
 *
 * @param expiry number in seconds
 */
const expiration = (expiry = 604800): Date => {
  const expires = new Date()
  expires.setTime(+expires + expiry * 1000)

  return expires
}

export default expiration
